import contractTermsHandlers from 'mocks/api/contractTerms';
import tokenHandlers from 'mocks/api/token';

export default [...contractTermsHandlers, ...tokenHandlers];
